import Rodape from "../../components/rodape";
import BusinessOtimize from "../../components/businessOtimize";
import SquadBeneficios from "../../components/squadBeneficios";
import BannerProjects from "../../components/bannerProjects";
import SquadDiferenciais from "../../components/squadDiferenciais";

function Squad() {
    return (
        <>
            <BannerProjects
                backgroundImage="../assets/cover-squad.png"
                bgMobile="../assets/cover-squad-mobile.png"
                title="/SQUAD"
                titleBold=""
                iconSrc="../assets/icone-projectiva-behub.png"
                iconAlt="Projectiva BeHub"
                iconText="be."
                iconTextBold="hub"
                descriptionBold=""
                description="Equipes multidisciplinares sob medida para vencer os desafios únicos do seu negócio."
                footerText="VERTICAL PROJECTS | Modelos de entrega"
                buttonText="Quero me conectar"
                buttonColor="from-[#4B3BDB] to-[#A002CB]"
                brand="behub"
            />
            <SquadBeneficios
                title={
                    <>
                        <p className="font-inter-light ">
                            Benefícios desse{" "}
                            <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] bg-clip-text text-transparent relative">
                                {" "}
                                modelo de entrega
                            </span>
                        </p>
                    </>
                }
                cards={[
                    {
                        icon: "../assets/servicos/equipes_icon.svg",
                        title: "Equipes Especializadas",
                        text: "Times multidisciplinares formados por profissionais como engenheiros, designers e especialistas que compreendem as necessidades únicas do seu negócio e a dinâmica de seu mercado.",
                        glowColor: "#A002CB",
                    },
                    {
                        icon: "../assets/servicos/abordagem_icon.svg",
                        title: "Abordagem Ágil e Flexível",
                        text: "Trabalhamos com metodologias ágeis que garantem entregas rápidas, flexíveis e eficientes, permitindo ajustes contínuos e a geração de alto valor estratégico.",
                        glowColor: "#A002CB",
                    },
                    {
                        icon: "../assets/servicos/compromisso_icon.svg",
                        title: "Compromisso Com a Entrega",
                        text: "Compromisso com a entrega. Garantimos entregas efetivas, com qualidade e pontualidade.",
                        glowColor: "#A002CB",
                    },
                    {
                        icon: "../assets/servicos/solucoes_icon.svg",
                        title: "Soluções Personalizadas",
                        text: "Desenvolvemos soluções personalizadas em aplicativos, software empresarial",
                        glowColor: "#A002CB",
                    },
                    {
                        icon: "../assets/servicos/colaboracao_icon.svg",
                        title: "Colaboração Transparente",
                        text: "Atuamos em parceria com nossos clientes, com comunicação transparente e colaboração contínua, em todas as etapas do projeto.",
                        glowColor: "#A002CB",
                    },
                ]}
            />
            <BusinessOtimize
                backgroundImage="../assets/background_mudancas.png"
                bgMobile="../assets/background_mudancas_mobile.png"
                title={
                    <>
                        Entregas efetivas com{" "}
                        <span className="font-inter-bold">
                            excelência em resultados.
                        </span>
                    </>
                }
                buttonText="Otimize seu negócio"
                buttonTextColor="from-[#A800E4] to-[#A800E4]"
                buttonLink="#"
            />
            <SquadDiferenciais
                leftColumnContent={{
                    title: (
                        <>
                            <p className="font-inter-light ">
                                Diferenciais desse{" "}
                                <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] bg-clip-text text-transparent relative">
                                    {" "}
                                    modelo de entrega
                                </span>
                            </p>
                        </>
                    ),
                    subtitle: "Outros modelos de entrega:",
                    items: [
                        { text: "Escopo fechado", link: "/escopo-fechado" },
                        { text: "Smartsourcing", link: "/smartsourcing" },
                    ],
                    buttonText: "Otimize seu negócio",
                    buttonLink: "#",
                }}
                rightColumnItems={[
                    {
                        id: "01",
                        title: "PARCERIA ESTRATÉGICA",
                        description:
                            "Atuamos em completa parceria com a sua equipe, construindo uma jornada única e personalizada para as necessidades e objetivos específicos do seu negócio.",
                    },
                    {
                        id: "02",
                        title: "APRENDIZADO CONTÍNUO",
                        description:
                            "Investimos no aperfeiçoamento contínuo das nossas equipes, liderando o mercado unindo expertise humana e inovação tecnológica.",
                    },
                    {
                        id: "03",
                        title: "SOLUÇÕES DE IMPACTO",
                        description:
                            "Criamos soluções que transformam negócios, agregam valor e impulsionam crescimento.",
                    },
                    {
                        id: "04",
                        title: "SUPORTE CONTÍNUO",
                        description:
                            "Após a entrega do projeto, proporcionamos atendimento, manutenção e atualizações de forma contínua.",
                    },
                    {
                        id: "05",
                        title: "MÉTRICAS TANGÍVEIS",
                        description:
                            "Acompanhamos a evolução de cada projeto com métricas claras e a mensuração de impactos e resultados.",
                    },
                ]}
            />
            <Rodape />
        </>
    );
}

export default Squad;
